const CompanyAccess = {
  dashboard: ["zotrai","trawtel", "babaair", "landairtravels"],
  Visas: ["zotrai","trawtel","babaair"],
  flights: ["zotrai","trawtel", "babaair", "landairtravels"],
  hotels: ["zotrai","trawtel","babaair", "landairtravels"],
  packages: ["zotrai","trawtel", "babaair", "landairtravels"],
  sightseeing: ["zotrai","trawtel", "babaair", "landairtravels"],
  umrah: ["zotrai","trawtel", "babaair"],
  hajj: ["zotrai","trawtel", "babaair"],
  marketing: ["zotrai","trawtel", "babaair", "landairtravels"],
  bus: ["zotrai","trawtel", "landairtravels"],
};
export default CompanyAccess;